:host {
  position: absolute;
  width: auto;
  height: auto;
  min-width: 320px;
}

:host([hidden]) {
  visibility: hidden;
  opacity: 0;
}

:host([isOpen]) {
  .container {
    visibility: visible;
    opacity: 1;
  }
}

.container {
  padding: calc(var(--spacer) * 3);
  border-radius: calc(var(--spacer) * 1.25);
  position: relative;
  visibility: hidden;
  opacity: 0;

  .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 18px 18px 18px;
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;

    &.arrow-position {
      &-top-right {
        top: -17px;
        right: 24px;
      }
      &-top-left {
        top: -17px;
        left: 24px;
      }
      &-right-top {
        top: 33px;
        right: -26px;
        transform: rotate(90deg);
      }
      &-right-bottom {
        bottom: 33px;
        right: -26px;
        transform: rotate(90deg);
      }
      &-bottom-left {
        bottom: -17px;
        left: 24px;
        transform: rotate(180deg);
      }
      &-bottom-right {
        bottom: -17px;
        right: 24px;
        transform: rotate(180deg);
      }
      &-left-top {
        top: 33px;
        left: -26px;
        transform: rotate(-90deg);
      }
      &-left-bottom {
        bottom: 33px;
        left: -26px;
        transform: rotate(-90deg);
      }
    }
  }
}
